import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetScheduleDto {
  @IsUUID()
  @IsNotEmpty()
  schedule_id: string;

  @IsUUID()
  @IsNotEmpty()
  company_id: string;
}
